import React from "react";
import axios from "axios";
import UserService from "./UserService";
import {getAuth} from "./ConfigServices";

const getAuthorization = async () => {
    const token = UserService.getToken();
    let permission = [];
    await axios
        .get(getAuth(), {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then((response) => {
            if (response.status === 200) {
                permission = response.data.permission;
                localStorage.setItem("userType", permission.usertype);
                localStorage.setItem("memv2version", permission.memv2version);
                localStorage.setItem("permission", JSON.stringify(permission.details));
                localStorage.setItem("memoptions", JSON.stringify(permission.options));
                let dashboard = response.data.dashboard.AnalysePage;
                localStorage.setItem("pageAnalyse", JSON.stringify(dashboard));
            } else {
                if (response.status === 401) {
                    console.log("not authenticated");
                }
            }
        })
        .catch((error) => {
            if (error.response) {
                console.error("ERROR", error);
            } else if (error.request) {
                console.error("request error", error.request);
                UserService.getLogout();
            }
        });
};

const AuthServices = {
    getAuthorization,
};
export default AuthServices;
